/**
 * Strings of the access of Phage.Energy to the client's station in DeyeCloud
 * (D3/D4, TZ-DEYE п. 5, prototype v14): «Додати об'єкт» → «Доступ», the chip
 * of the object screen, the row of «Налаштування», the administrator's
 * objects. D4: data and control go through this access.
 * Merged into `MESSAGES` (messages.ts); Ukrainian defines the key set.
 */
export const ACCESS_MESSAGES = {
  en: {
    'add.step.access': 'Access',
    'access.title': 'Access for Phage.Energy',
    'access.sub':
      'Through this access we see the data and calculate the effect for your object. Control of the battery is separate — «I want control» on the object page. The access lasts until you close it; the station stays in your account.',
    'access.howto.title': 'In the DeyeCloud app — for each station',
    'access.howto.1': 'Open the station → «Overview».',
    'access.howto.2': 'The icon at the top right → «Manage Access».',
    'access.howto.3': '«+Add» and enter the business name:',
    'access.howto.3_unknown': '«+Add» and find the business «Phage.Energy».',
    'access.howto.4': 'Rights: «Only view» — enough for the data and the calculation.',
    'access.howto.5': '«OK» — «Authorization succeeds» appears.',
    'access.copy': 'Copy',
    'access.copied': 'Copied',
    'access.copy_selected': 'Selected — copy it',
    'access.check.title': 'Check',
    'access.check': 'Check access',
    'access.later': 'Do it later',
    'access.done': 'Done',
    'access.status.pending': 'waiting for access',
    'access.status.open': 'access open',
    'access.status.closed': 'access closed',
    'access.status.noedit': 'view only',
    'access.result.open': 'Access open.',
    'access.result.pending':
      'We do not see the inverter yet: check the SN, the business name and the rights.',
    'access.result.closed':
      'The station is no longer in the Phage.Energy account: the access was closed in DeyeCloud. Open it again and check.',
    'access.result.noedit':
      'Access is open with «Only view»: the data comes. Control — «I want control» on the object page.',
    'access.unavailable':
      'The check is not available now. Open the access as described — we will check it later.',
    'access.limited': 'DeyeCloud limits sign-ins — check at {time}.',
    'access.next': 'Check again at {time}.',
    'access.row': 'Phage.Energy access',
    'access.row.open': 'open',
    'access.row.pending': 'waiting: we do not see the station in the Phage.Energy account yet',
    'access.row.closed': 'closed in DeyeCloud',
    'access.row.noedit': 'open with «Only view» · no control',
    'access.checked_at': 'checked {at}',
    'access.more': 'How to open or close the access in DeyeCloud',
    'access.more.1': 'Station → «Overview» → the icon at the top right → «Manage Access».',
    'access.more.2':
      'Open: «+Add» → «{name}» → «Only view» → «OK»; for control — «Can edit» or «Can manage».',
    'access.more.3': 'Close: choose {name} in the list and delete it.',
    'access.toast.done':
      'Access open. The original inverter settings are saved, nothing is changed. Downloading the history for 90 days.',
    'access.toast.later':
      'The objects are added and wait for access. Open the access in DeyeCloud — then the data starts coming.',
    'operator.sites.phage': 'Phage.Energy',
  },
  uk: {
    'add.step.access': 'Доступ',
    'access.title': 'Доступ для Phage.Energy',
    'access.sub':
      "Через цей доступ ми бачимо дані й рахуємо ефект для вашого об'єкта. Керування батареєю — окремо, кнопкою «Хочу керувати» на сторінці об'єкта. Доступ діє, доки ви його не закриєте; станція залишається у вашому акаунті.",
    'access.howto.title': 'У застосунку DeyeCloud — для кожної станції',
    'access.howto.1': 'Відкрийте станцію → «Overview».',
    'access.howto.2': 'Значок угорі праворуч → «Manage Access».',
    'access.howto.3': '«+Add» і введіть назву бізнесу:',
    'access.howto.3_unknown': '«+Add» і знайдіть бізнес «Phage.Energy».',
    'access.howto.4': 'Права: «Only view» — достатньо для даних і розрахунку.',
    'access.howto.5': "«OK» — з'явиться «Authorization succeeds».",
    'access.copy': 'Скопіювати',
    'access.copied': 'Скопійовано',
    'access.copy_selected': 'Виділено — скопіюйте',
    'access.check.title': 'Перевірка',
    'access.check': 'Перевірити доступ',
    'access.later': 'Зробити пізніше',
    'access.done': 'Готово',
    'access.status.pending': 'очікує доступу',
    'access.status.open': 'доступ відкрито',
    'access.status.closed': 'доступ закрито',
    'access.status.noedit': 'лише перегляд',
    'access.result.open': 'Доступ відкрито.',
    'access.result.pending': 'Ще не бачимо інвертор: перевірте SN, назву бізнесу й права.',
    'access.result.closed':
      'Станції більше немає в акаунті Phage.Energy: доступ закрито в DeyeCloud. Відкрийте його знову й перевірте.',
    'access.result.noedit':
      "Доступ відкрито з правом «Only view»: дані надходять. Керування — кнопкою «Хочу керувати» на сторінці об'єкта.",
    'access.unavailable':
      'Перевірка зараз недоступна. Відкрийте доступ за інструкцією — ми перевіримо його пізніше.',
    'access.limited': 'DeyeCloud обмежує вхід — перевірте о {time}.',
    'access.next': 'Перевірити ще раз можна о {time}.',
    'access.row': 'Доступ Phage.Energy',
    'access.row.open': 'відкрито',
    'access.row.pending': 'очікує: ми ще не бачимо станцію в акаунті Phage.Energy',
    'access.row.closed': 'закрито в DeyeCloud',
    'access.row.noedit': 'відкрито з правом «Only view» · без керування',
    'access.checked_at': 'перевірено {at}',
    'access.more': 'Як відкрити або закрити доступ у DeyeCloud',
    'access.more.1': 'Станція → «Overview» → значок угорі праворуч → «Manage Access».',
    'access.more.2':
      'Відкрити: «+Add» → «{name}» → «Only view» → «OK»; для керування — «Can edit» або «Can manage».',
    'access.more.3': 'Закрити: оберіть {name} у списку й видаліть.',
    'access.toast.done':
      'Доступ відкрито. Початкові налаштування інверторів збережено, нічого не змінено. Завантажуємо історію за 90 днів.',
    'access.toast.later':
      "Об'єкти додано й чекають доступу. Відкрийте доступ у DeyeCloud — тоді почнемо отримувати дані.",
    'operator.sites.phage': 'Phage.Energy',
  },
} as const;
